/**
 * @generated SignedSource<<997aebee4a875eb6ac0161c5e54c96dc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MemberOnboardingSlackManualConnectionStepsFragment$data = {
  readonly content: {
    readonly organization: {
      readonly slack: {
        readonly workspace: {
          readonly name: string | null;
          readonly url: string | null;
        } | null;
      } | null;
    };
  };
  readonly " $fragmentSpreads": FragmentRefs<"MemberOnboardingSlackRequestInviteFragment" | "MemberOnboardingSlackValidateConnectionFragment">;
  readonly " $fragmentType": "MemberOnboardingSlackManualConnectionStepsFragment";
};
export type MemberOnboardingSlackManualConnectionStepsFragment$key = {
  readonly " $data"?: MemberOnboardingSlackManualConnectionStepsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"MemberOnboardingSlackManualConnectionStepsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MemberOnboardingSlackManualConnectionStepsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Content",
      "kind": "LinkedField",
      "name": "content",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Organization",
          "kind": "LinkedField",
          "name": "organization",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SlackConnection",
              "kind": "LinkedField",
              "name": "slack",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SlackWorkspace",
                  "kind": "LinkedField",
                  "name": "workspace",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "url",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MemberOnboardingSlackValidateConnectionFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MemberOnboardingSlackRequestInviteFragment"
    }
  ],
  "type": "ContentUsage",
  "abstractKey": null
};

(node as any).hash = "ed26ec0bad4c55ef8311a7df42423496";

export default node;
